import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { EncryptionService } from "src/app/services/encryption.service";

@Component({
  selector: "app-header-tool-bar",
  templateUrl: "./header-tool-bar.component.html",
  styleUrls: ["./header-tool-bar.component.scss"],
  standalone: false
})
export class HeaderToolBarComponent implements OnInit {
  @Input() title;
  @Input() isVisible;
  isSubExpired: any;
  constructor( public router: Router, private encryptionService: EncryptionService) {}

  ngOnInit() {
    this.isSubExpired =this.encryptionService.decryptUsingAES256(JSON.parse(localStorage.getItem("isExpired")));
  }
  GoToNoti() {
    this.router.navigate(["agent-home/notifications"]);
  }
}
